<template>
    <div>
        <div v-if="Object.keys(stats).length === 0" class="row justify-content-around mt-5">
            {{ $t('AppOperationsStats.Não foi possível carregar as estatísticas') }}
        </div>
        <div v-else class="row justify-content-around">
            <div v-for="stat in stats" class="stat-card mb-4 mt-3" :class="colSize">
                <div class="stat-card__title">{{ stat.name }}</div>
                <div class="stat-card__body">
                    <div v-for="item in stat.stats" class="stat-row">
                        <span class="stat-row__label">{{ item.title }}</span>
                        <span class="stat-row__value">{{ item.value }} {{ item.symbol }}</span>
                    </div>
                </div>
            </div>
            <div :class="pane_size <= 45 ? 'row justify-content-around col-12 clear-padding' : 'mt-3 mb-2 col-3'">
                <div class="stat-card stat-card--list mb-4" :class="colListSize">
                    <div class="stat-card__title">{{ $t('AppOperationsStats.Operadores') }}</div>
                    <div class="stat-card__body">
                        <div v-if="operators.length === 0" class="stat-empty">---</div>
                        <template v-else>
                            <div v-for="operator in operators" class="stat-list-item">{{ operator }}</div>
                        </template>
                    </div>
                </div>
                <div class="stat-card stat-card--list mb-4" :class="colListSize">
                    <div class="stat-card__title">{{ $t('AppOperationsStats.Veículos') }}</div>
                    <div class="stat-card__body">
                        <div v-if="vehicles.length === 0" class="stat-empty">---</div>
                        <template v-else>
                            <div v-for="vehicle in vehicles" class="stat-list-item">{{ vehicle.display_name }}</div>
                        </template>
                    </div>
                </div>
                <div v-if="showVarietyList" class="stat-card stat-card--list" :class="[colListSize, {'mb-4': pane_size <= 45}]">
                    <div class="stat-card__title">{{ $t('AppOperationsStats.Variedades') }}</div>
                    <div class="stat-card__body">
                        <div v-if="varieties.length === 0" class="stat-empty">---</div>
                        <template v-else>
                            <div v-for="variety in varieties" class="stat-list-item">{{ variety }}</div>
                        </template>
                    </div>
                </div>
                <div v-if="showProductList" class="stat-card stat-card--list" :class="[colListSize, {'mb-4': pane_size <= 45}]">
                    <div class="stat-card__title">{{ $t('AppOperationsStats.Produtos') }}</div>
                    <div class="stat-card__body">
                        <div v-if="products.length === 0" class="stat-empty">---</div>
                        <template v-else>
                            <div v-for="product in products" class="stat-list-item">{{ product }}</div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            colSize: 'col-5',
            colListSize: this.numberOfLists === 2 ? 'col-5 inline' : 'col-3 inline',
            numberOfLists: 2,
            showProductList: false,
            showVarietyList: false
        }
    },
    methods: {
        setColSize(paneSize) {
            if (this.isScreenMobile) {
                this.colSize = 'col-11'
                this.colListSize = 'col-11 inline'
                return;
            }

            if (paneSize > 45) {
                this.colSize = 'col-4'
                this.colListSize = 'col-11'
                return
            }

            if (paneSize > 25) {
                this.colSize = 'col-5'
                this.colListSize = this.numberOfLists === 2 ? 'col-5 inline' : 'col-3 inline'
                return
            }

            this.colSize = 'col-11'
            this.colListSize = 'col-11 inline'
        }
    },
    props: {
        stats: {
            type: Object,
            required: true
        },
        operators: {
            type: Array
        },
        operation: {
            type: Object
        },
        vehicles: {
            type: Array
        },
        varieties: {
            type: Array
        },
        products: {
            type: Array
        },
        pane_size: {
            type: Number
        }
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    },
    watch: {
        pane_size: {
            handler(size) {
                this.setColSize(size)
            }
        },
        operation: {
            immediate: true,
            handler(op) {
                switch (op.operation_type) {
                    case 'TRANSPORT':
                    case 'TILLAGE':
                        this.numberOfLists = 2
                        this.showProductList = false
                        this.showVarietyList = false
                        break;
                    case 'SEEDING':
                    case 'HARVEST':
                    case 'MOWING':
                        this.numberOfLists = 3
                        this.showProductList = false
                        this.showVarietyList = true
                        break;
                    case 'LIQUID_APPLICATION':
                    case 'DRY_APPLICATION':
                        this.numberOfLists = 3
                        this.showProductList = true
                        this.showVarietyList = false
                        break;
                }
                this.setColSize(this.pane_size)
            }
        }
    }
}
</script>

<style scoped lang="scss">

@import "src/assets/styles/constants";

$accent: $aside-menu-item-active;

.stat-card {
    background: #fff;
    border: 1px solid #e8ecee;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
    overflow: hidden;
    padding-bottom: 10px;
    margin-right: 1rem;
    margin-left: 1rem;
}

.stat-card__title {
    color: $accent;
    font-weight: 700;
    font-size: 11px;
    letter-spacing: .8px;
    text-transform: uppercase;
    text-align: left;
    padding: 12px 12px 8px;
    margin-bottom: 6px;
    border-bottom: 1px solid rgba($accent, .3);
}

.stat-card__body {
    padding: 0 12px;
}

.stat-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
    padding: 5px 0;
    border-bottom: 1px solid #f1f3f4;
    font-size: 13px;
}

.stat-row:last-child {
    border-bottom: 0;
}

.stat-row__label {
    color: #6b7280;
    text-align: left;
}

.stat-row__value {
    color: #2b2b2b;
    font-weight: 600;
    text-align: right;
    white-space: nowrap;
}

.stat-list-item {
    padding: 4px 0;
    border-bottom: 1px solid #f1f3f4;
    font-size: 13px;
    color: #2b2b2b;
    text-align: left;
}

.stat-list-item:last-child {
    border-bottom: 0;
}

.stat-empty {
    color: #9ca3af;
    text-align: center;
    padding: 6px 0;
}

.inline {
    margin-top: 1rem;
    margin-right: 1rem;
    margin-left: 1rem;
}

.clear-padding {
    padding-right: 0;
    padding-left: 0;
}
</style>
